import { SelectProps } from "@cofano/cck/Select/Select";
import { DemurrageCalculationRoundingRule } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const RoundingRuleSelect = ({ value, onChange }: Omit<SelectProps<DemurrageCalculationRoundingRule, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(DemurrageCalculationRoundingRule)}
			getOptionLabel={(option) => intl.formatMessage({ id: `ROUNDING_RULE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default RoundingRuleSelect;
